<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  header="Detalhes da Distribuição de Dividendos"
  styleClass="app-detail-dialog"
  [style]="{ width: '90vw', maxWidth: '1100px' }"
  [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }"
  (onHide)="fechar()">

  <div class="dialog-content-wrapper" *ngIf="dividendo">
    <div class="detail-card">
      <div class="detail-header">
        <div class="header-icon">
          <i class="pi pi-chart-line"></i>
        </div>
        <div class="header-info">
          <h2 class="detail-title">{{ dividendo.formaDistribuicaoDescricao }}</h2>
          <p class="detail-subtitle">
            Distribuído em {{ dividendo.dataDistribuicao | date:'dd/MM/yyyy' }}
            <span class="header-separator">•</span>
            {{ dividendo.quantidadeBeneficiarios }} beneficiário(s)
          </p>
        </div>
        <div class="header-badges">
          <p-tag
            [value]="dividendo.statusDividendoDescricao"
            [severity]="getStatusPagamentoSeverity(dividendo.statusDividendoDescricao)">
          </p-tag>
          <span class="status-badge status-reinf">{{ dividendo.statusReinfDescricao }}</span>
        </div>
      </div>

      <div class="resumo-valores">
        <div class="valor-card valor-card--bruto">
          <div class="valor-card__icon"><i class="pi pi-dollar"></i></div>
          <div class="valor-card__content">
            <span class="valor-card__label">Valor Bruto</span>
            <span class="valor-card__value">{{ dividendo.valorBrutoTotal | currency:'BRL' }}</span>
          </div>
        </div>
        <div class="valor-card valor-card--ir">
          <div class="valor-card__icon"><i class="pi pi-percentage"></i></div>
          <div class="valor-card__content">
            <span class="valor-card__label">Valor de IR</span>
            <span class="valor-card__value">{{ dividendo.valorIrTotal | currency:'BRL' }}</span>
          </div>
        </div>
        <div class="valor-card valor-card--liquido">
          <div class="valor-card__icon"><i class="pi pi-wallet"></i></div>
          <div class="valor-card__content">
            <span class="valor-card__label">Valor Líquido</span>
            <span class="valor-card__value">{{ dividendo.valorLiquidoTotal | currency:'BRL' }}</span>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title">
          <i class="pi pi-calendar"></i>
          <span>Dados da Distribuição</span>
        </div>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-calendar"></i><span>Data de Distribuição</span></div>
            <div class="detail-value">{{ dividendo.dataDistribuicao | date:'dd/MM/yyyy' }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-calendar-plus"></i><span>Data de Pagamento</span></div>
            <div class="detail-value">{{ dividendo.dataPagamento ? (dividendo.dataPagamento | date:'dd/MM/yyyy') : 'Não informada' }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-credit-card"></i><span>Forma de Pagamento</span></div>
            <div class="detail-value">{{ dividendo.formaPagamentoDescricao }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-chart-line"></i><span>Forma de Distribuição</span></div>
            <div class="detail-value">{{ dividendo.formaDistribuicaoDescricao }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-sliders-h"></i><span>Modo de Distribuição</span></div>
            <div class="detail-value">{{ dividendo.modoDistribuicaoBeneficiarioDescricao }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-users"></i><span>Beneficiários</span></div>
            <div class="detail-value">{{ dividendo.quantidadeBeneficiarios }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-flag"></i><span>Status do Pagamento</span></div>
            <div class="detail-value">
              <p-tag
                [value]="dividendo.statusDividendoDescricao"
                [severity]="getStatusPagamentoSeverity(dividendo.statusDividendoDescricao)">
              </p-tag>
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-send"></i><span>Status REINF</span></div>
            <div class="detail-value">
              <span class="status-badge" [ngClass]="getStatusReinfClass(dividendo.statusReinfDescricao)">
                {{ dividendo.statusReinfDescricao }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title">
          <i class="pi pi-users"></i>
          <span>Beneficiários</span>
        </div>
        <p-table
          [value]="dividendo.beneficiarios"
          responsiveLayout="scroll"
          styleClass="detail-table">
          <ng-template pTemplate="header">
            <tr>
              <th>Sócio</th>
              <th>CPF</th>
              <th *ngIf="isModoProporcional">Participação (%)</th>
              <th>Valor Bruto</th>
              <th>IR</th>
              <th>Líquido</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-beneficiario>
            <tr>
              <td>
                <div class="beneficiario-nome">
                  <i class="pi pi-user"></i>
                  <span>{{ beneficiario.nomeSocio || '—' }}</span>
                </div>
              </td>
              <td>{{ formatarCpf(beneficiario.cpfSocio) }}</td>
              <td *ngIf="isModoProporcional">{{ beneficiario.percentual != null ? (beneficiario.percentual + ' %') : '—' }}</td>
              <td class="col-valor">{{ beneficiario.valorBruto | currency:'BRL' }}</td>
              <td class="col-valor col-valor--ir">{{ beneficiario.valorIr | currency:'BRL' }}</td>
              <td class="col-valor col-valor--liquido">{{ beneficiario.valorLiquido | currency:'BRL' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="isModoProporcional ? 6 : 5" class="empty-row">Nenhum beneficiário cadastrado.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="info-section" *ngIf="historicosOrdenados.length">
        <div class="section-title">
          <i class="pi pi-history"></i>
          <span>Histórico</span>
        </div>
        <div class="historico-timeline">
          <div class="historico-item" *ngFor="let historico of historicosOrdenados">
            <div class="historico-item__icon" [ngClass]="getHistoricoIconClass(historico.tipoHistoricoDescricao)">
              <i [class]="getHistoricoIcon(historico.tipoHistoricoDescricao)"></i>
            </div>
            <div class="historico-item__content">
              <div class="historico-item__header">
                <strong>{{ historico.tipoHistoricoDescricao }}</strong>
                <span class="historico-item__data">{{ historico.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
              </div>
              <p class="historico-item__observacao" *ngIf="historico.observacao">{{ historico.observacao }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton label="Fechar" icon="pi pi-times" class="p-button-secondary" (click)="fechar()"></button>
  </ng-template>
</p-dialog>
